<div mat-dialog-title>
    {{ data.title | translate }}
</div>
<div mat-dialog-content>
    <mat-form-field>
        <mat-label>{{ (data.label ?? 'ALDEN.DIALOGS.CHOOSE_OPTION.LABEL') | translate }}</mat-label>
        <mat-select [(ngModel)]="data.selectedOption" [compareWith]="compareFn">
            <mat-option *ngFor="let option of data.options" [value]="option">{{option.value | translate}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="accent">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.NO_LABEL' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="data.selectedOption"
        [disabled]="data.selectedOption === null || data.selectedOption === undefined" color="primary">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.YES_LABEL' | translate }}
    </button>
</div>
